import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, Attribute, ChangeDetectorRef
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl, AbstractControl, Validator, ValidatorFn
} from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  UserContext
} from '../../../../services/user-context/user-context';
import * as moment from 'moment';
import {ApiService} from '../../../../services/api';
import {Observable, Subscription} from 'rxjs';
import {HttpParams} from '@angular/common/http';

@Component({
  selector: 'app-client-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'client-dialog.template.html',
  styles: [
    "app-client-dialog mat-dialog-container {padding:0;}",
    "app-client-dialog mat-dialog-content.mat-dialog-content {background:#f7fafc;padding:24px;}",
    "app-client-dialog mat-dialog-actions {display:flex;flex-direction: row;justify-content: space-between;}"
  ]
})

export class ClientDialogComponent implements OnInit {
  public form: FormGroup;
  public formErrors = {
    lastName: '',
    firstName: '',
    email: '',
    type: '',
    currency: '',
    name: '',
    phone: ''
  };
  locations:any[];
  client:any;
  users:any[];
  telehealth = false;
  countries = ['US', 'CA'];
  genders = [{label: 'Male', value: 'm'}, {label:'Female', value: 'f'}];

  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<ClientDialogComponent>,
              private userContext: UserContext,
              private api: ApiService,
              private changeDetect: ChangeDetectorRef,
              @Inject(MAT_DIALOG_DATA) public data: any) {


    this.api.get<any[]>('/user', new HttpParams().set('account', this.userContext.account.id).set('provider', 'true'))
      .subscribe(result => {
        this.users = result.filter(u => u.firstName && u.lastName && (this.userContext.isAssociate() ? u.id === this.userContext.user.reference : true));
        let currentUser = this.users.find( u => u.id.includes(userContext.user.reference));
        if( currentUser ) {
          this.form.controls['user_id'].setValue(currentUser.user_id);
        }
      });

    if( data ) {
      this.client = data;
    } else {
      this.client = {};
    }

  }

  public ngOnInit(): void {
    if(!this.client.id) {
      this.api.get<any>(`/account/${(this.userContext.account || {}).id}/location`)
        .subscribe(locations => {
          if (locations) {
            this.locations = locations;
          }
        });
    }
    this.buildForm();
  }

  public ngOnDestroy(): void {
  }

  public buildForm() {
    this.form = this.formBuilder.group({
      lastName: new FormControl((this.client || {}).lastName, [
        Validators.required,
        Validators.minLength(2)
      ]),
      firstName: new FormControl((this.client || {}).firstName, [
        Validators.required,
        Validators.minLength(2)
      ]),
      email: new FormControl((this.client || {}).email, [
        Validators.required,
        Validators.email,
        Validators.minLength(3)
      ]),
      dob: new FormControl(this.client.dob ? moment(this.client.dob).toDate() : null, [
        Validators.required
      ]),
      gender: new FormControl(this.client.gender, [
        Validators.required
      ]),
      occupation: new FormControl(this.client.occupation, [
      ]),
      address: new FormControl(this.client.address, [
      ]),
      address2: new FormControl(this.client.address2, [
      ]),
      postal: new FormControl(this.client.postal, [
      ]),
      city: new FormControl(this.client.city, [
      ]),
      region: new FormControl(this.client.region, [
      ]),
      country: new FormControl(this.client.country, [
      ]),
      phone: new FormControl((this.client || {}).phone, [
        Validators.required,
        Validators.minLength(10)
      ]),
      height: new FormControl((this.client.biometric || {}).height, [
      ]),
      weight: new FormControl((this.client.biometric || {}).weight, [
      ]),
      shoe: new FormControl((this.client.biometric || {}).shoe, [
      ]),
      user_id: new FormControl(null, [
      ]),
      when: new FormControl(moment().add(1, 'day').toDate(), [
      ]),
      subject: new FormControl(null, [
      ]),
      confirmed: new FormControl(null, [
      ]),
    });
    if( !this.client.id ) {
      this.form.addControl("location_id",new FormControl(null, [
        Validators.required
      ]))
    }

    this.form.valueChanges
      .subscribe(data => this.onValueChanged(data));
  }

  public toggleTelehealthFields() {
    this.telehealth = !this.telehealth;
    if( this.telehealth ) {
      this.form.get('user_id').setValidators([Validators.required]);
      this.form.get('when').setValidators([Validators.required]);
      this.form.get('subject').setValidators([Validators.required]);
    } else {
      this.form.get('user_id').clearValidators();
      this.form.get('when').clearValidators();
      this.form.get('subject').clearValidators();
    }
    this.form.get('user_id').updateValueAndValidity();
    this.form.get('when').updateValueAndValidity();
    this.form.get('subject').updateValueAndValidity();
    this.changeDetect.detectChanges();
  }

  public onValueChanged(data?: any): void {
    if (!this.form) { return; }
    const form = this.form;

    for ( const field of Object.keys( this.formErrors) ) {
      this.formErrors[field] = '';
      const control = form.get(field);

      if (control && control.dirty && !control.valid) {
        for ( const key of Object.keys( control.errors ) ) {
          //this.formErrors[field] = messages[key];
        }
      }
    }
  }

  public isAdministrator() {
    return this.userContext.hasRole('administrator');
  }

  public isManager() {
    return this.userContext.hasRole('manager');
  }

  public save() {
    let biometric = Object.assign({}, this.client.biometric || {});
    biometric.height = this.form.value.height;
    if( biometric.height )
      biometric.heightUnits = 'in';
    biometric.weight = this.form.value.weight;
    if( biometric.weight )
      biometric.weightUnits = 'lb';
    biometric.shoe = this.form.value.shoe;
    if( biometric.shoe )
      biometric.shoeUnits = 'US';
    this.client = Object.assign(this.client, {
      firstName: this.form.value.firstName,
      lastName: this.form.value.lastName,
      email: this.form.value.email,
      phone: this.form.value.phone,
      dob: this.form.value.dob.toISOString(),
      address: this.form.value.address,
      address2: this.form.value.address2,
      city: this.form.value.city,
      gender: this.form.value.gender,
      region: this.form.value.region,
      country: this.form.value.country,
      occupation: this.form.value.occupation,
      biometric: biometric
    });
    if( !this.client.account_id ) {
      this.client.account_id = this.userContext.account.id;
    }
    if( !this.client.location_id ) {
      this.client.location_id = this.form.value.location_id;
    }
    if( this.telehealth ) {
      this.client.telehealth = {
        user_id: this.form.value.user_id,
        when: this.form.value.when.toISOString(),
        subject: this.form.value.subject,
        confirmed: !!this.form.value.confirmed
      }
    }
    this.dialogRef.close(this.client);
  }

  public cancel() {
    this.dialogRef.close();
  }
}
